import {imageExists, projectshortCode, toTitleCase} from "../../../resources/constants";
import React from "react";
import {serverLink} from "../../../resources/url";

const DashboardStudentInfo = (props) => {
    return (
        <>
            <div className="col-md-6 d-flex">
                <div className="flex-fill">
                    <div className="card bg-dark position-relative">
                        <div className="card-body">
                            <div className="d-flex align-items-center row-gap-3 mb-3">
                                <div className="avatar avatar-xxl rounded flex-shrink-0 me-3">
                                    <img src={ imageExists(`${serverLink}public/uploads/${projectshortCode}/application/document/${props.studentInformation.studentID}`) ? `${serverLink}public/uploads/${projectshortCode}/application/document/${props.studentInformation.studentID}` : require('../../images/user.png')} alt="Img"/>
                                </div>
                                <div className="d-block">
                                    <span className="badge bg-transparent-primary text-primary mb-1" style={{fontSize: '16px'}}>{props.studentInformation.studentID}</span>
                                    <h3 className="text-truncate text-white mb-1">{props.studentInformation.studentName}</h3>
                                    <div className="d-flex align-items-center flex-wrap row-gap-2 text-gray-2">
                                        <span className="border-end me-2 pe-2">{toTitleCase(props.studentInformation.studentCourse)}</span>
                                        <span className="border-end me-2 pe-2">{props.studentInformation.studentLevel} Level</span>
                                        <span>{toTitleCase(props.studentInformation.studentSemester)} Semester</span>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between profile-footer flex-wrap row-gap-3 pt-4">
                                <div className="d-flex align-items-center">
                                    <h6 className="text-white">Status: </h6>
                                    <span className="badge bg-success d-inline-flex align-items-center ms-2"><i className="ti ti-circle-filled fs-5 me-1"></i>{toTitleCase(props.studentInformation.studentStatus)}</span>
                                </div>
                                {/*<a href="edit-student.html" className="btn btn-primary">Edit Profile</a>*/}
                            </div>
                            <div className="student-card-bg">
                                <img src={require('../../images/bg/circle-shape.png')} alt="Bg"/>
                                <img src={require("../../images/bg/shape-02.png")} alt="Bg"/>
                                <img src={require("../../images/bg/shape-04.png")} alt="Bg"/>
                                <img src={require("../../images/bg/blue-polygon.png")} alt="Bg"/>
                            </div>
                        </div>
                    </div>
                    <div className="card flex-fill">
                        <div className="card-body d-flex justify-content-center align-items-center">
                            <div className="text-center  align-items-center" style={{height: '250px'}}>
                                <br/>
                                <h1 style={{fontSize: '80px'}}>{props.cgpa ?? 0}</h1><br/>
                                <h4>Cumulative Grade Point Average (CGPA)</h4>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DashboardStudentInfo;